<script>
    import { range } from '$lib/utils'
    import Typography from './Typography.svelte'
    import { ChevronBackOutline, ChevronFordware } from '../Icons/'
    export let total
    let controller
    export let size = 15
    export let currentPage = 1
    export let spaces = 4
    let pages
    let block = 1
    function arrowLeft() {
        currentPage = currentPage > 1 ? currentPage - 1 : currentPage
    }
    function arrowRight() {
        currentPage = currentPage !== pages ? currentPage + 1 : currentPage
    }
    function leftPad() {
        block = block !== blocks ? block + 1 : block
    }
    function rightPad() {
        block = block !== 1 ? block - 1 : block
    }
    // $: spaces = spaces < pages ? spaces : 1;
    $: pages = Math.ceil(total / size)
    $: blocks = Math.ceil(pages / spaces)
    $: block = currentPage <= spaces ? 1 : Math.ceil(currentPage / spaces)
    $: st =
        block == 1
            ? 1
            : block === blocks
              ? pages - spaces + 1
              : spaces * (block - 1) + 1 // block * Math.ceil() // pages - currentPages;
    $: ed =
        block == 1
            ? pages < spaces
                ? pages
                : spaces
            : block === blocks
              ? pages
              : spaces * block
    $: controller = {
        print: range(st, ed + 1),
        st,
        ed,
        first: 1,
        last: pages,
        currentPage,
        blocks,
        block,
        rightPad: block !== 1,
        leftPad: block !== blocks,
    }
</script>

<div>
    <span class="button" on:click={arrowLeft}
        ><ChevronBackOutline color="var(--color-grey-800)" /></span
    >
    <span class="container">
        {#if controller.rightPad}
            <i
                class="counted"
                class:active={currentPage === 1}
                on:click={(_) => (currentPage = 1)}>1</i
            >
            <i on:click={rightPad}>...</i>
        {/if}
        {#each controller.print as i (i)}
            {@const class_ =
                i === currentPage ? 'active' : i < currentPage ? 'counted' : ''}
            <i
                class={class_}
                on:click={(_) => {
                    currentPage = i
                }}><Typography>{i}</Typography></i
            >
        {/each}
        {#if controller.leftPad}
            <i on:click={leftPad}>...</i>
            <i on:click={(_) => (currentPage = pages)}>{pages}</i>
        {/if}
    </span>
    <span class="button" on:click={arrowRight}
        ><ChevronFordware color="var(--color-grey-800)" /></span
    >
</div>

<style>
    i {
        color: var(--color-grey-400);
        margin: 0;
        padding: 0;
        /* width: 15px; */
        display: flex;
        /* height: 30px; */
        justify-content: center;
        align-items: center;
        user-select: none;
        height: auto;
        position: relative;
        cursor: pointer;
        transition: color 0.2s ease-in-out;
    }
    div {
        /* width: 150px; */
        height: 30px;
        padding: 0;
        margin: 0;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
    }
    .container {
        padding: 0 30px;
        gap: 21px;
        height: 30px;
        display: flex;
        flex-direction: row;
    }
    .button {
        cursor: pointer;
    }
    .counted {
        color: var(--color-grey-800);
    }
    .active {
        /* content: ''; */
        height: 30px;
        /* display: inline-block; */
        width: 30px;
        /* z-index: -1;
        position: absolute;
        top:0;
        left:0; */
        margin: 0 -10px 0 -10px;
        background: var(--color-brand-primary-01);
        color: var(--color-white);
        border-radius: 5px;
    }
</style>
